import {
  React,
  Component,
  withRouter,
  withCookies,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  ProjectList,
  ProjectsList
} from 'imports/ComponentsImports';

import {
  Stepper,
  CountdownTimer,
} from 'imports/DesignImports';

import {
  CircularProgress,
  Divider
} from 'material-ui';

const styles = {
  pageContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    marginLeft: '10px'
  },
  stepperContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '2px #F0F0EF solid',
    marginBottom: '5px',
    fontFamily: 'Lato'
  },
  informationContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: '10px 0px 20px 0px'
  },
  addProjectButton: {
    border: '2px #212F55 solid',
    fontFamily: 'Lato',
  }
}

class ProjectsView extends Component {
  constructor(props){
    super(props);
    this.state = {
      token: this.props.cookies.get('token'),
      user: this.props.cookies.get('user'),
      error: false,
      loading: true,
    }
  }

  componentDidMount(){
    this.getProjects();
  }

  render() {
    if(this.state.error){
      return(
        <div style={{display: 'flex', justifyContent: 'center', marginTop:'20px'}}>
          <p>Error al cargar los proyectos. Por favor recarga la página o intenta más tarde.</p>
        </div>
      )
    }
    if(this.state.loading){
      return(
          <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop:'20px'}}>
            <CircularProgress color='#9e9e9e' size={80} thickness={5} />
          </div>
      )
    }
    if(this.props.done){
      return(
        <div>
          <h1 style={styles.header}> Fichas de proyectos </h1>
          <div style={styles.informationContainer}>
            <div style={styles.informationText}>Estos son los proyectos que fueron medidos para obtener el índice de intensidad de innovación</div>
          </div>
          <ProjectList
            history={this.props.history}
            projects={this.state.projects}
            apiToken={this.state.token}
            shownData={["name", "area", "leader", "progress", "view"]}/>
        </div>
      );
    }

    return (
      <div style={styles.pageContainer}>
        <h1 style={styles.header}> Portafolio de Proyectos </h1>
        <Stepper step="files" style={{marginTop: '-20px'}} />
        <Divider style={{margin: '15px'}}/>
        <div style={styles.informationContainer}>
          {this.state.user.position === 'Líder de proyecto' ?
          <div style={styles.informationText}>
            Estos son los proyectos que lideras del portafolio de innovación seleccionado para medir i3.
            <br/>Deberás completar la ficha de cálculo de cada uno de ellos para evaluar su impacto.
          </div> :
          <div style={styles.informationText}>
            Estos son los proyectos de tu portafolio de innovación para medir i3.
          </div>
          }
            <CountdownTimer step="files" token={this.state.token} company_id={this.state.user.company_id}/>
        </div>
          <ProjectsList />
      </div>
    );
  }

  getProjects = () => {
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.state.token}
    });
    connection.get(routes.projectFullInformation)
      .then((response) => {
        this.setState({
          projects: response.data.filter((project) => {return project.state.length > 0 && (project.state[0].state === "En desarrollo" || project.state[0].state === "No trazable" || project.state[0].state === "En proceso de firma" || project.state[0].state === "Ficha aprobada")}),
          loading: false,
          error:false
        })
      })
      .catch((error) => {
        console.log(error);
        this.setState({ error: true, loading: false })
      });
  }
}

export default withCookies(withRouter(ProjectsView));



// WEBPACK FOOTER //
// ./src/views/files/FilesView.js